import DateFnsUtils from '@date-io/date-fns';
import { CssBaseline } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import React, { Suspense, useState } from 'react';
import { GqlApiProvider } from './api/client';
import { PermissionContext } from './contexts/PermissionContext';
import Routes from './Routes';
import {
  AuthProviderWrapper,
  ThemeProvider,
  storeInitialTenant,
} from 'unity-fluent-library';
import { storeInitialPath } from './utils/redirect/LocalRedirectUrlStorage';
import './styles.scss';

let App = () => {
  const [permissionOptions] = useState({
    level: 'silver',
    option: true,
    mapOption: true,
    mapEditOption: true,
    mapViewOption: true,
  });
  storeInitialPath();
  storeInitialTenant();

  return (
    <Suspense fallback="loading">
      <ThemeProvider>
        <AuthProviderWrapper>
          <PermissionContext.Provider value={permissionOptions}>
            <GqlApiProvider>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <CssBaseline />
                <Routes />
              </MuiPickersUtilsProvider>
            </GqlApiProvider>
          </PermissionContext.Provider>
        </AuthProviderWrapper>
      </ThemeProvider>
    </Suspense>
  );
};

export default App;
